export interface ReportDelivery {
  spend?:number|null;impressions?:number|null;metrics_state?:string;
  delivery_start_at?:string|null;
}
/** CRM display policy, separate from Meta's stored effective_status. */
export function reportDeliveryStatus(status:string|null,metrics:ReportDelivery,now=Date.now()):string|null {
  if(!['ACTIVE','Scheduled'].includes(status??''))return status;
  const start=Date.parse(metrics.delivery_start_at??'');
  if(Number.isFinite(start)&&start>now)return 'Scheduled';
  if(status==='Scheduled'&&!Number.isFinite(start))return status;
  const spend=metrics.spend,impressions=metrics.impressions;
  if(metrics.metrics_state!=='unknown'&&((spend!=null&&spend>0)||(impressions!=null&&impressions>0)))return 'ACTIVE';
  if(!['unknown','partial'].includes(metrics.metrics_state??'')&&spend===0&&impressions===0)return 'Preparing';
  return status==='Scheduled'?'ACTIVE':status;
}

export function applyDeliveryTransitions<T extends {active:number;scheduled?:number;preparing?:number}>(counts:T,transitions:Array<{at:string;status:string|null}>,now:number):T {
  const result={...counts};
  for(const transition of transitions)if(Date.parse(transition.at)<=now&&(result.scheduled??0)>0) {
    if(transition.status==='Preparing'){result.scheduled=(result.scheduled??0)-1;result.preparing=(result.preparing??0)+1;}
    else if(transition.status==='ACTIVE'){result.scheduled=(result.scheduled??0)-1;result.active++;}
  }
  return result;
}
